<inline-skjema>
  <!-- venter på https://github.com/angular/angular/pull/55880 for [formArray] støtte -->
  <form data-testid="stemmeberettigedeskjema" [formGroup]="skjema" (ngSubmit)="lagre()" navigasjonforhindret-flash>

  <table>
    <tr>
      <th class="valgt">
        <mat-checkbox (click)="endreAlle()" [indeterminate]="!alleValgt() && !ingenValgt()" [checked]="alleValgt()" matTooltip="{{'Velg alle eller ingen deltakere'|translate}}" data-testid="velg-alle"/>
        {{ 'Skal stemme'|translate }}
      </th>
      @if(visAntallAksjer()){
        <th colspan="2">
          {{ 'Antall aksjer'|translate }}
          <a (click)="setStemmevektTilAntallAksjerForAlle()">{{'Kopier alle til stemmevekt'|translate}} <i class="ion-ios-arrow-thin-right"></i></a>
        </th>
      }
      <th>{{ 'Stemmevekt'|translate }}</th>
      <th>{{ 'Kommentar'|translate }}</th>
    </tr>
    <tbody>
    @for (rad of skjema.controls; track rad.value.deltaker!.id;) {
      <tr data-testid="stemmeberettiget">
        <td class="valgt">
          <mat-checkbox [formControl]="rad.controls.erStemmeberettiget" data-testid="er-stemmeberettiget">
            {{rad.value.deltaker!.medlem.navn}}
          </mat-checkbox>
        </td>
        @if(visAntallAksjer()){
          <td class="antall">{{rad.value.antallAksjerTotalt}}</td>
          <td>
            @if(rad.value.antallAksjerTotalt != rad.value.stemmevekt && rad.value.erStemmeberettiget){
              <a (click)="setStemmevektTilAntallAksjer(rad)">{{'kopier til'|translate }} <i class="ion-ios-arrow-thin-right"></i></a>
            }
          </td>
        }
        <td>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dense-3 stemmevekt">
            <input matInput [formControl]="rad.controls.stemmevekt" type="number" placeholder="{{'Stemmevekt'|translate}}" name="stemmevekt" data-testid="stemmevekt">
            @if(rad.controls.stemmevekt.hasError('stemmevekt_mangler')){
              <mat-error data-testid="stemmevekt_mangler">{{'Stemmevekt må være et tall > 0'|translate}}</mat-error>
            }
          </mat-form-field>
        </td>
        <td class="kommentar">
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dense-3 kommentar">
            <input matInput [formControl]="rad.controls.stemmekommentar" placeholder="{{'Kommentar'|translate}}" name="kommentar" data-testid="stemmekommentar">
          </mat-form-field>
        </td>
      </tr>
    }
    </tbody>
  </table>

  <inline-skjema-handlinger navigasjonforhindret-flash>
    <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
      {{ "Lagre"|translate }}
    </button>
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  </inline-skjema-handlinger>

</form>
</inline-skjema>
